import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {BankDetails} from '../../models/bank-details.model';

@Injectable({
  providedIn: 'root'
})
export class BankService {
  constructor(private readonly http: HttpClient) {
  }

  fetchActiveBanks(): Observable<BankDetails[]> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get<BankDetails[]>('api/bank', { headers });
  }
}
